import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GgwDeviceParamListComponent } from './components/ggw-device-param-list/ggw-device-param-list.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UIBaseModule} from "@catui/ui-base.module";
import {UIFormModule} from "@catuiform/ui-form.module";
import { ModifyGgwDeviceParamComponent } from './components/modify-ggw-device-param/modify-ggw-device-param.component';
import {FeatureGgwDeviceParamService} from "@catmodules/models/ggw-device-params/services/feature-ggw-device-param.service";
import {SlideInModalModule} from "@catmodules/widgets/slide-in-modal/slide-in-modal.module";
import {ProjectGgwDeviceParamService} from "@catmodules/models/ggw-device-params/services/project-ggw-device-param.service";
import { CreateGgwDevParamsFromXmlComponent } from './components/create-ggw-dev-params-from-xml/create-ggw-dev-params-from-xml.component';
import {DialogModule, InputTextareaModule} from "primeng/primeng";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ParametersModule} from "@catmodels/parameters/parameters.module";

const publicComponents = [
    GgwDeviceParamListComponent,
    ModifyGgwDeviceParamComponent,
    CreateGgwDevParamsFromXmlComponent,
];

const imports = [
    CommonModule,
    FormsModule,
    UIBaseModule,
    UIFormModule,
    DialogModule,
    InputTextareaModule,
    ReactiveFormsModule,
    SlideInModalModule,
    ParametersModule,
];
const declarations = [
    ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [
    FeatureGgwDeviceParamService,
    ProjectGgwDeviceParamService,
];
const entryComponents = [...publicComponents];

@NgModule({
    declarations,
    entryComponents,
    exports: exportings,
    imports,
    providers,
})
export class GgwDeviceParamsModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-device-params/ggw-device-params.module.ts